import { Input } from 'component/Input'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { PhoneFormStore } from 'store/profile/PhoneFormStore'

type Props = {
  it: PhoneFormStore
}

export const PhoneInput = observer(({ it }: Props) => {
  const { touch, value, error } = it
  const showError = touch && !!error

  const onRef = useLatestCallback((element: HTMLInputElement | null) => {
    it.element = element ?? undefined
  })

  const onChange = useLatestCallback((value: string) => {
    it.value = value
  })

  return <Vertical>
    <Input ref={onRef} large panel error={showError} value={value}
      placeholder={i18n('PhonePlaceholder')} onChange={onChange} />
    {showError && <Gap height={4} />}
    {showError && <Typo size={12} error>{error}</Typo>}
  </Vertical>
})
